import { AnimatedSwitch } from "@components/common/AnimatedSwitch/AnimatedSwitch";
import { useBannerTop } from "@components/common/BannerTop/useBannerTop";
import { Button } from "@kirvanobr/button";
import { ModalContent, ModalFooter } from "@kirvanobr/modal";
import { Link } from "@kirvanobr/link";
import { Typography } from "@kirvanobr/typography";
import { Info } from "../../Info/Info";
import { FooterProps } from "./SellerWithProducts.types";

export function SellerWithProducts() {
  const { requirementsHelpUrl, handleRedirection } = useBannerTop();

  function DesktopFooter({ onClose }: FooterProps) {
    return (
      <section className="hidden md:flex">
        <Button
          color="tertiary"
          size="md"
          radius="full"
          fullWidth
          className="bg-transparent text-foreground-600"
          onClick={onClose}
        >
          Deixar para depois
        </Button>
        <Button
          color="primary"
          size="md"
          radius="full"
          fullWidth
          onClick={() => {
            handleRedirection("/products");
            onClose();
          }}
        >
          Acessar produtos
        </Button>
      </section>
    );
  }

  function MobileFooter({ onClose }: FooterProps) {
    return (
      <ModalFooter className="md:hidden">
        <Button color="primary" size="md" radius="full" fullWidth onClick={onClose}>
          Ok, entendi
        </Button>
      </ModalFooter>
    );
  }

  return (
    <ModalContent>
      {onClose => (
        <>
          <section>
            <div className="w-full text-center">
              <div className="w-full h-[120px] rounded-md bg-[url('/assets/banners/banner-marketplace-modal.png')] bg-cover" />
              <Typography variant="title" size="t4" weight="bold" className="mt-4">
                Marketplace de afiliados
              </Typography>
              <Typography variant="body" size="t4" weight="regular" className="mt-2">
                Siga os passos a seguir
              </Typography>
            </div>
          </section>

          <section>
            <ul className="list-disc px-6 space-y-3">
              <li>
                <Typography variant="body" size="t4" weight="regular">
                  Clique no produto que deseja disponibilizar para afiliação;
                </Typography>
              </li>
              <li>
                <Typography variant="body" size="t4" weight="regular">
                  Na navegação esquerda da tela: <b>clique em afiliação</b>;
                </Typography>
              </li>
              <li>
                <div className="flex items-baseline gap-3">
                  <Typography variant="body" size="t4" weight="regular">
                    <b>Ative</b> a afiliação;
                  </Typography>
                  <AnimatedSwitch />
                </div>
              </li>
              <li>
                <Typography variant="body" size="t4" weight="regular">
                  Acesse as <b>preferências</b>;
                </Typography>
              </li>
              <li>
                <div className="flex items-baseline gap-3">
                  <Typography variant="body" size="t4" weight="regular">
                    <b>Ative</b> a exibição do seu produto no Marketplace.
                  </Typography>
                  <AnimatedSwitch />
                </div>
              </li>
            </ul>
          </section>

          <section>
            <Info>
              <>
                Seu produto ficará visível caso cumpra todos os{" "}
                <Link
                  style={{ fontSize: "inherit" }}
                  color="primary"
                  variant="underline"
                  isBlock={false}
                  underline="always"
                  target="_blank"
                  href={requirementsHelpUrl}
                >
                  requisitos
                </Link>
                . Não perca a chance de ter seus produtos em destaque e multiplicar suas vendas com a ajuda de afiliados
                parceiros.
              </>
            </Info>
          </section>

          <DesktopFooter onClose={onClose} />
          <MobileFooter onClose={onClose} />
        </>
      )}
    </ModalContent>
  );
}
